import { animate, style, transition, trigger } from '@angular/animations';

export const bubbleAnimation = [
  trigger('bubbleAnimation', [
    transition(':enter', [
      style({ height: 0, opacity: 0, marginTop: 0, paddingTop: 0, marginBottom: 0, paddingBottom: 0 }),
      animate('200ms ease-out', style('*')),
    ]),
    transition(':leave', [
      style('*'),
      animate('200ms ease-in', style({ height: 0, opacity: 0, marginTop: 0, paddingTop: 0, paddingBottom: 0, marginBottom: 0 })),
    ]),
  ]),
];
